import { useEffect } from 'react';

const useScrollReveal = (selector = '.glass-card, .story-block, .highlight-card') => {
  useEffect(() => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(22px)';
    });

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.transition = 'opacity .6s ease, transform .6s ease';
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );

    elements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [selector]);
};

export default useScrollReveal;
